import { ProjectEntryMethod, RadioButtonGroupData } from "../../../models";
import { RadioButtonGroup } from "../../forms";
import { ProjectEntryMethodToggleProps } from "./models";

const DATA: RadioButtonGroupData = [
  { key: "manual", value: "Manual entry" },
  { key: "upload", value: "Bulk upload" },
];

export const ProjectEntryMethodToggle = ({
  value,
  onChange,
  disabled = false,
}: ProjectEntryMethodToggleProps): JSX.Element => (
  <div className="ProjectEntryMethodToggle">
    <RadioButtonGroup
      label="How would you like to add your project(s)?"
      data={DATA}
      value={value}
      disabled={disabled}
      direction="horizontal"
      onChange={(e) => onChange(e.target.value as ProjectEntryMethod)}
    />
  </div>
);
